
import { loadingController, modalController } from "@ionic/vue";
import { ref } from "vue";
import { route } from "@/router";

import { useListStore } from "@/stores/lists";
import { usePersistentStore } from "@/stores/persistent";
import { useSupplierStore } from "@/stores/suppliers";

import { useLoader } from "@/composables/useLoader";

import { isApp } from "@/functions/enviroment";

import { SORT_METHOD } from "@/types/enum/propEnum";
import { isCatalogCached, isListItemsCached } from "@/functions/checks";

export function useCatalogFilter(listId?: string) {
    const supplierStore = useSupplierStore()
    const listStore = useListStore()
    const { showLoading, hideLoading } = useLoader()

    const tempCategory = ref<Record<string, boolean>>(JSON.parse(JSON.stringify(supplierStore.catalogFilter.category)))
    const tempSortDirection = ref<SORT_METHOD>(supplierStore.catalogFilter.sortDirection)

    const getCatalogItems = async (supplierId: string, specialOffers?: boolean, change?: boolean): Promise<void> => {
        supplierStore.isLoaded.catalog = (isCatalogCached(supplierId, listId) || !change)
        if (isApp()) listStore.isLoaded.listItems = (isListItemsCached(listId) || !change)
        if (usePersistentStore().offlineMode) {
            setTimeout(async () => {
                supplierStore.isLoaded.catalog = true
                if (isApp() && listId) listStore.isLoaded.listItems = true
                if ((await loadingController.getTop())) await hideLoading()
                if (await modalController.getTop()) await modalController.dismiss()
            }, 200)
            return;
        }

        const searchKey = supplierStore.searchQuery
        const category = supplierStore.activeCategoriesNames

        await supplierStore.getCatalog({
            locationId: route.value.params.locationId as string,
            supplierId,
            searchKey,
            category,
            specialOffersOnly: specialOffers,
            includeList: listId
        })

        supplierStore.isLoaded.catalog = true
        if (isApp() && listId) listStore.isLoaded.listItems = true
        if ((await loadingController.getTop())) await hideLoading()
        if (await modalController.getTop()) await modalController.dismiss()
        window.dispatchEvent(new Event('force-reload-catalog'))
    }

    const resetFilters = (): void => {
        supplierStore.catalogFilter.category = {}
        supplierStore.catalogFilter.sortDirection = SORT_METHOD.ALPH_ASC
    }

    const assignFilters = (): void => {
        supplierStore.catalogFilter.category = tempCategory.value
        supplierStore.catalogFilter.sortDirection = tempSortDirection.value
    }

    const resetChanges = async (supplierId: string): Promise<void> => {
        resetFilters()
        supplierStore.isLoaded.catalog = false

        await showLoading()
        await getCatalogItems(supplierId)
    }

    const applyChanges = async (supplierId: string): Promise<void> => {
        assignFilters()
        if (usePersistentStore().offlineMode) {
            if ((await loadingController.getTop())) await hideLoading()
            if (await modalController.getTop()) await modalController.dismiss()
            return
        }
        supplierStore.isLoaded.catalog = false

        await showLoading()
        await getCatalogItems(supplierId)
    }

    return {
        getCatalogItems,
        resetChanges,
        applyChanges,
        tempCategory,
        tempSortDirection
    }
}
